export default "__VITE_ASSET__C4Ca9V9U__"